<div *transloco="let t" [outerHTML]="t('shared/gdprInfo', { gdprContractUrl })"></div>
